<div class="manage-view">
  <button class="btn-small" type="button" (click)="back()" [disabled]="busy">
    &larr; Back
  </button>

  <h3 class="margin-top-small">
    {{ providerLabel }}
    <span class="status-chip status-{{ uiStatus }}">{{ statusChip }}</span>
  </h3>

  @if (status?.last_verified_at; as lastVerified) {
  <div class="muted small">Last verified: {{ formatTime(lastVerified) }}</div>
  }

  @if (isExpired) {
  <!-- SRA003-430: terminal expired state — non-green banner + reconnect CTA. -->
  <div class="expired-banner" role="alert">
    <p class="muted small">
      The {{ providerLabel }} connection has expired — telemetry has stopped
      flowing into Harvest Mate. Reconnect to resume.
    </p>
    <button
      class="btn-small btn-primary"
      type="button"
      (click)="reconnect()"
      [disabled]="busy"
    >
      {{ busy ? 'Reconnecting…' : 'Reconnect telemetry' }}
    </button>
  </div>
  }

  <!-- Connection-wide actions stay above the tabs — they act on the whole
       connection, not on any single tab's concern. -->
  <div class="actions">
    <button
      class="btn-oem-primary"
      type="button"
      (click)="reLink()"
      [disabled]="busy"
    >
      Re-link account
    </button>
    <button
      class="btn-oem-primary-outline"
      type="button"
      (click)="disconnect()"
      [disabled]="busy"
    >
      Disconnect
    </button>
  </div>

  <!-- Each concern is a tab. Bodies use *matTabContent so a panel (and its
       API calls) only initialise when its tab is first opened — the eager
       stack previously loaded every panel at once. preserveContent keeps a
       panel alive once opened (Material destroys off-screen tab bodies by
       default), so switching away and back does NOT re-run ngOnInit / re-fetch.
       Deere lands on Data access (index 0) so the grant → machines → farms
       sequence reads top-to-bottom. -->
  <mat-tab-group
    class="manage-tabs"
    animationDuration="200ms"
    [preserveContent]="true"
  >
    @if (isDeere) {
    <mat-tab>
      <ng-template mat-tab-label>
        Data access
        @if ((status.orgs?.pending ?? 0) !== 0) {
        <span class="tab-badge" aria-label="organisations pending">{{
          status.orgs?.pending
        }}</span>
        }
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-body">
          <app-per-org-grants-panel
            [provider]="provider"
          ></app-per-org-grants-panel>
        </div>
      </ng-template>
    </mat-tab>
    }

    <mat-tab label="Machines">
      <ng-template matTabContent>
        <div class="tab-body">
          <app-machine-link-panel
            [provider]="provider"
            [providerLabel]="providerLabel"
            [grantsGated]="isDeere"
            [status]="status"
          ></app-machine-link-panel>
        </div>
      </ng-template>
    </mat-tab>

    <!-- SRA003-449 split farm+field linkage onto its own page to declutter the
         manage view; this tab gives that same separation while keeping the user
         on-page — the reused farm/field panels are inlined here rather than
         launching out. The standalone /integrations/farms/:provider route is
         left in place as a deep-link target (FarmFieldLinkPageComponent renders
         the same two panels). -->
    <mat-tab label="Farms &amp; fields">
      <ng-template matTabContent>
        <div class="tab-body">
          <app-farm-link-panel
            [provider]="provider"
            [providerLabel]="providerLabel"
          ></app-farm-link-panel>

          <app-field-link-panel
            [provider]="provider"
            [providerLabel]="providerLabel"
          ></app-field-link-panel>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="Health &amp; diagnostics">
      <ng-template matTabContent>
        <div class="tab-body">
          <app-connection-health-panel
            [provider]="provider"
            [providerLabel]="providerLabel"
            [status]="status"
          ></app-connection-health-panel>

          <app-telemetry-diagnostic-panel
            [provider]="provider"
            [providerLabel]="providerLabel"
          ></app-telemetry-diagnostic-panel>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <!--
    TODO(SRA003-390 Phase 2+): contractor-facing telemetry surface. SRA003-404
    (the diagnostic panel above) is a display-only TEST tool over the same OEM
    feed. Phase 2 is the polished contractor view — most recent N field
    operations shown inline (not behind a "pull test data" action) so growers/
    contractors can confirm telemetry is flowing AND see what arrived.
  -->
</div>
